export const config = {
	apiUrl: import.meta.env.VITE_API_URL,
	debugMode: import.meta.env.VITE_DEBUG_MODE === 'true',
}
